import { render, staticRenderFns } from "./FooterTUDOBOM.vue?vue&type=template&id=04f84f7a&scoped=true"
import script from "./FooterTUDOBOM.vue?vue&type=script&lang=js"
export * from "./FooterTUDOBOM.vue?vue&type=script&lang=js"
import style0 from "./FooterTUDOBOM.vue?vue&type=style&index=0&id=04f84f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f84f7a",
  null
  
)

export default component.exports